<template>
  <div class="menu-200-main shadow pt-2 ">
    <div class="menu-200 row m-0">

      <div class="p-0 menu-200-right-section d-inline-block ">

        <div class="menu-200-item my-2 p-1 rounded-lg text-center" v-for="item in selectedMenu"
             @click="showSubMenu(item)"
             :class="[item.id == menuItem.id ? 'menu-200-active' : '', 'menu-200-item']">

          <div v-if="item.children.length">
            <m-menu-icon-manager class="mx-auto d-block" :itemIcon="item.icon_class"/>
            <span class="d-block">{{ item.name }}</span>
          </div>

          <m-a target="_blank" :href="item.url" v-else>
            <m-menu-icon-manager class="mx-auto d-block" :itemIcon="item.icon_class"/>
            <span class="d-block">{{ item.name }}</span>
          </m-a>


        </div>

      </div>

      <div class="tab-content menu-200-left-section d-inline-block  mr-2" id="v-pills-tabContent"
           v-if="children.length">
        <div class="tab-pane fade show active " id="v-pills-home" role="tabpanel"
             aria-labelledby="v-pills-home-tab">
          <div class="accordion menu-200-submenu" :id="`id`">
            <div class="card  p-2 m-2 border-0">
              <div class="menu-200-submenu border-bottom mt-1" id="headingOne">
                <p class="m-0 mb-2 p-0 text-center">{{ menuItem.name }}</p>
              </div>
              <div>
                <menu-item v-for="menu in children" :item="menu"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import mA from '../../Tags/A.vue'
import mModal1 from '../../Tool/Modal/Modal1.vue'
import mLogin1 from "../../Authentication/Login/Login1.vue";
import {MenuProps} from "../MenuProps";
import mMenuIconManager from "../MenuIconManager.vue";
import MenuItem from "../../Menu/Menu200/MenuItem.vue";

export default defineComponent({
  name: "Menu200",
  components: {MenuItem, mMenuIconManager, mA, mModal1, mLogin1},
  props: {
    ...MenuProps,
  },
  data() {
    return {
      active: 0,
      children: [],
      menuItem: {},
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      profile: 'User/getProfile',
      storeMenus: "Menu/getAllMenus",
    }),
    selectedMenu() {
      let result = []
      this.storeMenus.forEach(item => {
        if (item.position === this.menuPosition) {
          result = item.children
        }
      })
      return result
    }
  },
  methods: {
    showSubMenu(item) {
      this.children = item.children
      this.menuItem = item
    },
  },
  mounted() {
  },

})
</script>

<style scoped>

.menu-200-main * {
  color: black;

}

.menu-200-item {
  word-wrap: break-word;
  font-size: 13px;
}

.menu-200-active {
  background: #e1e1e1;

}

.menu-200-active * {

  color: black;
}

.menu-200-right-section {
  width: 17%;
}

.menu-200-left-section {
  width: 80%;
}

</style>